<template>
  <div class="tab_home">
    <div class="overview app_card">
      <div class="overview_grid">
        <div class="overview_grid_title">{{ $t('代理账户') }}</div>
        <div class="overview_grid_value">{{ userInfo.id }}</div>
      </div>
      <div class="overview_grid">
        <div class="overview_grid_title">{{ $t('代理模式') }}</div>
        <div class="overview_grid_value green">{{ $t('有效投注') }}</div>
      </div>
      <!-- <div class="overview_grid">
        <div class="overview_grid_title">{{ $t('投注流水倍数') }}</div>
        <div class="overview_grid_value">{{ 0.00 }}</div>
      </div>
      <div class="overview_grid">
        <div class="overview_grid_title">{{ $t('结算日') }}</div>
        <div class="overview_grid_value">{{ 1 }}</div>
      </div> -->
    </div>
    <div class="invite app_card">
      <div class="invite_head">{{ $t('邀请好友') }}</div>
      <div class="invite_qr">
        <div class="qr_img">
          <img :src="verConfig.url + 'api/other/qrcode?text=' + encodeURIComponent(this.shareUrl) + '&size=180'"
            alt="" />
        </div>
        <div class="text_id">
          {{ $t("My.MemberInformation.Invitation") }}(ID)
          <div class="share_code green">
            {{ userInfo.share_code }}
          </div>
        </div>
        <div class="url">
          <div class="url_text">{{ shareUrl }}</div>
        </div>
        <div class="copy" @click="copy">{{ $t("newAdd.copy") }}</div>
      </div>
    </div>
    <div class="revenue_card app_card">
      <div class="revenue_card_item">
        <div class="muted">{{ $t('累计获得') }}</div>
        <div class="value" style="color:#c98210">{{ $money(obj?.total_commission || '0.00') }}</div>
      </div>
      <div class="revenue_card_item">
        <div class="muted">{{ $t('累计邀请人数') }}</div>
        <div class="value">{{ obj?.total_register_users || 0 }}</div>
      </div>
    </div>
    <!-- <div class="commission_summary app_card">
      <div class="commission_summary_head">{{ $t('我的佣金') }}</div>
      <div class="summary_grid">
        <div class="summary_grid_item">
          <div class="label">{{ $t('昨日直属业绩') }}</div>
          <div class="value">{{ $money('0.00') }}</div>
        </div>
        <div class="summary_grid_item">
          <div class="label">{{ $t('昨日直属佣金') }}</div>
          <div class="value">{{ $money('0.00') }}</div>
        </div>
        <div class="summary_grid_item">
          <div class="label">{{ $t('今日直属业绩') }}</div>
          <div class="value">{{ $money('0.00') }}</div>
        </div>
        <div class="summary_grid_item">
          <div class="label">{{ $t('今日直属佣金') }}</div>
          <div class="value">{{ $money('0.00') }}</div>
        </div>
        <div class="summary_grid_item">
          <div class="label">{{ $t('已领取佣金') }}</div>
          <div class="value">{{ $money('0.00') }}</div>
        </div>
        <div class="summary_grid_item">
          <div class="label">{{ $t('代发佣金') }}</div>
          <div class="value" style="color:#c98210">{{ $money('0.00') }}</div>
        </div>
      </div>
      <div class="btn">{{ $t('领取') }}</div>
    </div> -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { AGENT_SUMMARY } from "@/api";
import { Toast } from "vant"
export default {
  data() {
    return {
      obj:{}
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    shareUrl() {
      return window.location.origin + '/#/login?id=' + (this.userInfo.share_code || '')
    },
  },
  created() {
    this.$store.dispatch("getuserInfo");
    this.getData();
  },
  methods: {
    copy() {
      this.$copyText(this.shareUrl).then(() => {
        Toast(this.$t('复制成功'));
      });
    },
    async getData() {
      try {
        const res = await AGENT_SUMMARY();
        this.obj = res.data
      } catch (error) { }
    }
  }
}
</script>
<style lang="less" scoped>
.app_card {
  box-shadow: none;
}

.tab_home {
  margin-top: 12px;
  display: flex;
  gap: 12px;
  flex-direction: column;

  .overview {
    padding: 18px 16px;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px 18px;
    box-shadow: none;

    .overview_grid {
      .overview_grid_title {
        color: #7a8597;
        font-size: 14px;
      }

      .overview_grid_value {
        color: #0F172a;
        font-size: 20px;
        margin-top: 8px;
        font-weight: 600;
        line-height: 1.1;
        overflow-wrap: anywhere;
        word-break: break-word;
      }
    }
  }

  .invite {
    padding: 18px 16px;
    box-shadow: none;

    .invite_head {
      font-weight: 600;
      font-size: 22px;
    }

    .invite_qr {
      margin-top: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .qr_img {
        padding: 10px;
        border-radius: 12px;
        border: 1px solid rgba(15, 23, 42, .08);
      }

      .text_id {
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #7a8597;
        font-size: 14px;
        font-weight: 600;

        .share_code {
          font-size: 18px;
          margin-top: 4px;
        }
      }

      .url {
        display: flex;
        gap: 16px;
        padding: 16px;
        background: #0f172a0a;
        border-radius: 18px;
        margin-top: 12px;
      }

      .copy {
        margin-top: 12px;
        background: linear-gradient(90deg, #8ff5d1, #31e2a5);
        color: #064b38;
        box-shadow: 0 9px 20px #31e2a547;
        font-weight: 600;
        font-size: 14px;
        height: 44px;
        width: 100%;
        border-radius: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .revenue_card {
    padding: 16px;
    display: flex;
    justify-content: space-between;
    gap: 12px;

    .revenue_card_item {
      .muted {
        color: #7a8597;
        font-size: 16px;
      }

      .value {
        font-size: 24px;
        margin-top: 8px;
        font-weight: 600;
      }
    }
  }

  .commission_summary {
    padding: 16px;

    .commission_summary_head {
      margin: 0 0 12px;
      font-size: 17px;
      font-weight: 600;
    }

    .summary_grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 14px;

      .summary_grid_item {
        padding: 8px 0;

        .label {
          color: #7a8597;
          font-size: 14px;
        }

        .value {
          color: #071f2a;
          font-size: 20px;
          margin-top: 8px;
          font-weight: 600;
        }
      }
    }

    .btn {
      margin-top: 12px;
      background: linear-gradient(90deg, #8ff5d1, #31e2a5);
      color: #064b38;
      box-shadow: 0 9px 20px #31e2a547;
      font-weight: 600;
      font-size: 14px;
      height: 44px;
      width: 100%;
      border-radius: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.green {
  color: #31e2a5 !important;
}
</style>